"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusContext = exports.getInitialState = exports.focusReducer = void 0;
var react_1 = __importDefault(require("react"));
var _1 = require("./");
var setFocus = function (focusState) {
    if (focusState === void 0) { focusState = {}; }
    return __assign({ searchFocus: false, optionFocus: null, actionFocus: null, filterFocus: false, triggerFocus: false }, focusState);
};
var focusReducer = function (state, action) {
    switch (action.type) {
        case _1.FocusActionType.SetFocus: {
            return setFocus(__assign({}, action.payload));
        }
        default:
            return setFocus();
    }
};
exports.focusReducer = focusReducer;
var getInitialState = function (search, header, options, preventFocus, tree) {
    var searchExists = !!search || !!(header === null || header === void 0 ? void 0 : header.search);
    var firstOption = _1.getFirstOption(options, tree);
    if (preventFocus) {
        return {
            searchFocus: false,
            optionFocus: null,
            actionFocus: null,
            filterFocus: false,
            triggerFocus: false,
        };
    }
    return {
        searchFocus: searchExists,
        optionFocus: searchExists || !options ? null : firstOption,
        actionFocus: null,
        filterFocus: false,
        triggerFocus: !searchExists && !firstOption,
    };
};
exports.getInitialState = getInitialState;
exports.FocusContext = react_1.default.createContext(null);
//# sourceMappingURL=FocusContext.js.map